"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames3 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _handlers = require("../../helpers/handlers");
var _Button = _interopRequireWildcard(require("../ui/Button"));
var _EditableContentControl = require("../ui/EditableContentControl");
var _EditButton = require("./components/EditButton");
var _angleDown = _interopRequireDefault(require("./img/angleDown.svg"));
var _blankImage = _interopRequireDefault(require("./img/blankImage.svg"));
var _delete = _interopRequireDefault(require("./img/delete.svg"));
var _check = _interopRequireDefault(require("./img/check.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CompactCardView = function CompactCardView(_ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(className, _styles.default.item, _defineProperty({}, _styles.default.active, active), _defineProperty({}, _styles.default.disabled, disabled)),
    onClick: onClick
  }, children);
};
CompactCardView.propTypes = {
  active: _propTypes.default.bool,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
var SuccessOverlay = function SuccessOverlay(_ref2) {
  var onCancel = _ref2.onCancel,
    onConfirm = _ref2.onConfirm;
  var _useTranslation = (0, _reactI18next.useTranslation)('COMPACT_CARD_VIEW'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.overlay
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.overlayStatus
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.statusIcon,
    dangerouslySetInnerHTML: {
      __html: _check.default
    }
  }), t('OVERLAY_SUCCESS_MESSAGE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.overlayButton,
    onClick: onConfirm
  }, t('OVERLAY_CONFIRM_BUTTON')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.overlayButton,
    onClick: onCancel
  }, t('OVERLAY_CANCEL_BUTTON')));
};
var Image = function Image(_ref3) {
  var src = _ref3.src;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.image,
    style: {
      backgroundImage: src ? "url(\"".concat(src, "\")") : 'none'
    }
  }, !src && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.blankImage,
    dangerouslySetInnerHTML: {
      __html: _blankImage.default
    }
  }));
};
Image.propTypes = {
  src: _propTypes.default.string
};
var Body = function Body(_ref4) {
  var allowEditable = _ref4.allowEditable,
    description = _ref4.description,
    editing = _ref4.editing,
    icon = _ref4.icon,
    title = _ref4.title,
    onClick = _ref4.onClick,
    onEditTitle = _ref4.onEditTitle;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    editMode = _useState2[0],
    setEditMode = _useState2[1];
  var onConfirm = function onConfirm(nextTitle) {
    if (nextTitle) {
      onEditTitle(nextTitle, function () {
        return setEditMode(false);
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.body,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.bodyInner
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.editWrapper
  }, editMode ? /*#__PURE__*/_react.default.createElement(_EditableContentControl.EditableContentControl, {
    editing: editing,
    value: title,
    onClose: function onClose() {
      return setEditMode(false);
    },
    onConfirm: onConfirm
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.titleText,
    title: title
  }, title), allowEditable && /*#__PURE__*/_react.default.createElement(_EditButton.EditButton, {
    onClick: (0, _handlers.handleWith)(_handlers.stop, function () {
      return setEditMode(true);
    })
  }), icon && /*#__PURE__*/_react.default.createElement("span", {
    className: _styles.default.titleIcon,
    dangerouslySetInnerHTML: {
      __html: icon.element
    },
    title: icon.title
  }))), description && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.desc
  }, description)));
};
Body.propTypes = {
  allowEditable: _propTypes.default.bool,
  description: _propTypes.default.any,
  editing: _propTypes.default.bool,
  icon: _propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    element: _propTypes.default.any.isRequired
  }),
  title: _propTypes.default.any,
  onClick: _propTypes.default.func,
  onEditTitle: _propTypes.default.func
};
var Collapse = function Collapse(_ref5) {
  var children = _ref5.children,
    className = _ref5.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, children);
};
Collapse.propTypes = {
  children: _propTypes.default.any,
  className: _propTypes.default.string
};
var Buttons = function Buttons(_ref6) {
  var deleting = _ref6.deleting,
    isCollapsed = _ref6.isCollapsed,
    onCollapseButtonClick = _ref6.onCollapseButtonClick,
    onArrowButtonClick = _ref6.onArrowButtonClick,
    onDeleteButtonClick = _ref6.onDeleteButtonClick,
    collapseButtonClassName = _ref6.collapseButtonClassName,
    _ref6$loadingForArrow = _ref6.loadingForArrowButton,
    loadingForArrowButton = _ref6$loadingForArrow === void 0 ? false : _ref6$loadingForArrow;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.buttons,
    onClick: _handlers.stop
  }, onArrowButtonClick && /*#__PURE__*/_react.default.createElement(_Button.default, {
    loading: loadingForArrowButton,
    circle: true,
    className: (0, _classnames3.default)(_styles.default.button, collapseButtonClassName),
    icon: _angleDown.default,
    size: _Button.SIZES.MEDIUM,
    theme: _Button.THEMES.WHITE,
    activeTheme: _Button.THEMES.WHITE,
    onClick: onArrowButtonClick
  }), onDeleteButtonClick && /*#__PURE__*/_react.default.createElement(_Button.default, {
    circle: true,
    className: _styles.default.button,
    disabled: deleting,
    icon: _delete.default,
    size: _Button.SIZES.MEDIUM,
    theme: _Button.THEMES.WHITE,
    activeTheme: _Button.THEMES.WHITE,
    onClick: !deleting ? onDeleteButtonClick : undefined
  }), onCollapseButtonClick && /*#__PURE__*/_react.default.createElement(_Button.default, {
    circle: true,
    className: (0, _classnames3.default)(_styles.default.button, isCollapsed && _styles.default.isCollapsed),
    icon: _angleDown.default,
    size: _Button.SIZES.MEDIUM,
    theme: _Button.THEMES.WHITE,
    activeTheme: _Button.THEMES.WHITE,
    onClick: onCollapseButtonClick
  }));
};
Buttons.propTypes = {
  deleting: _propTypes.default.bool,
  loadingForArrowButton: _propTypes.default.bool,
  isCollapsed: _propTypes.default.bool,
  onArrowButtonClick: _propTypes.default.func,
  onCollapseButtonClick: _propTypes.default.func,
  onDeleteButtonClick: _propTypes.default.func,
  collapseButtonClassName: _propTypes.default.string
};
CompactCardView.SuccessOverlay = (0, _react.memo)(SuccessOverlay);
CompactCardView.Image = (0, _react.memo)(Image);
CompactCardView.Body = (0, _react.memo)(Body);
CompactCardView.Buttons = (0, _react.memo)(Buttons);
CompactCardView.Collapse = (0, _react.memo)(Collapse);
var _default = exports.default = CompactCardView;